import List from '@material-ui/core/List';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import NavItem from './NavItem';

/*
Register Fuse Navigation Components
 */

const useStyles = makeStyles((theme) => ({
	navigation: {
		'& .list-item': {
			'&:hover': {
				backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0,0,0,.04)',
			},
			'&:focus:not(.active)': {
				backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.06)' : 'rgba(0,0,0,.05)',
			},
		},
	},
	verticalNavigation: {
		'&.active-square-list': {
			'& .list-item, & .active.list-item': {
				width: '100%',
				borderRadius: '0',
			},
		},
		'&.dense': {
			'& .list-item': {
				paddingTop: 0,
				paddingBottom: 0,
				height: 32,
			},
		},
	},
	'@global': {
		'.popper-navigation-list': {
			'& .list-item': {
				padding: '8px 12px 8px 12px',
				height: 20,
				minHeight: 20,
				'& .list-item-text': {
					padding: '0 0 0 8px',
				},
			},
			'&.dense': {
				'& .list-item': {
					minHeight: 32,
					height: 32,
					'& .list-item-text': {
						padding: '0 0 0 8px',
					},
				},
			},
		},
	},
}));

const FuseNavigation = ({ navigation, active, className }) => {
	const classes = useStyles();

	if (!navigation.length) {
		return null;
	}

	return (
		<List
			className={clsx(
				'navigation whitespace-nowrap',
				classes.navigation,
				classes.verticalNavigation,
				`active-${active}-list`,
				className
			)}
		>
			{navigation.map((_item) => (
				<NavItem key={_item.id} type={`vertical-${_item.type}`} item={_item} nestedLevel={0} />
			))}
		</List>
	);
};

FuseNavigation.propTypes = {
	navigation: PropTypes.array.isRequired,
	active: PropTypes.oneOf(['square', 'rounded']),
	className: PropTypes.string,
};

export default React.memo(FuseNavigation);
